import type { RequestConfig } from '@customTypes/index';
import type { ActivityItem, PaginatedResponse } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetAllActivityesListParams = RequestConfig;

export const getAllActivityesList = async ({
  config
}: GetAllActivityesListParams) =>
  api.get<PaginatedResponse<ActivityItem[]>>(`/api/UserActivities/all`, config);
